import { Form, Input, Modal, Button, InputNumber } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { RiCloseLine } from "react-icons/ri";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import DragUpload from "../../../commons/DragUpload/DragUpload";
import { Error, Success } from "../../../commons/Messages/Messages";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import "./ServiceProviders.css";

import { useTranslation } from "react-i18next";
const EditServiceProviders = ({ data, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [logo, setLogo] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = async values => {
    await axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/service-providers/update/${data?._id}`,
        { ...values, logo },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    form.setFieldsValue(data);
    form.setFieldValue("maxEmployees", data?.settings?.maxEmployees);

    form.setFieldValue("defaultRoles", data?.settings?.defaultRoles);
    form.setFieldValue("allowedCustomRoles", data?.settings?.allowedCustomRoles);
  }, [data, form]);

  return (
    <>
      <MainButtonComp text="Edit" editBtn onClick={showModal} />
      <Modal
        destroyOnClose
        title={t("Edit Service Provider")}
        width={640}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" type="primary" htmlType="submit" form="admin-edit-service-provider">
            {t("Submit")}
          </Button>
        ]}
        open={isModalOpen}
        onCancel={handleCancel}
        closeIcon={<RiCloseLine />}
        width={640}
      >
        <Form
          id="admin-edit-service-provider"
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          initialValues={{
            picture: {},
            firstName: "",
            lastName: "",
            username: "",
            email: "",
            serviceProviderId: "",
            phone: "",
            companyName: ""
          }}
        >
          <Form.Item
            name="picture"
            label={t("Picture")}
            rules={[{ required: true, message: t("Picture is required") }]}
          >
            <DragUpload
              accept="image"
              value={[data?.picture]}
              noMultiple
              updateFiles={val => form.setFieldValue("picture", val[0])}
            />
          </Form.Item>
          <Form.Item name="logo" label={t("Logo")}>
            <DragUpload
              accept="image"
              noMultiple
              value={[data?.logo]}
              updateFiles={val => setLogo(val[0])}
            />
          </Form.Item>
          <Form.Item
            name="firstName"
            label={t("First Name")}
            rules={[{ required: true, message: t("First Name is required") }]}
          >
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item name="lastName" label={t("Last Name")}>
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item name="username" label={t("Username")}>
            <Input autoComplete="off" autoCapitalize="none" spellCheck={false} />
          </Form.Item>
          <Form.Item
            name="email"
            label={t("Email")}
            rules={[
              { required: true, message: t("Email is required") },
              { type: "email", message: t("Invalid email format") }
            ]}
          >
            <Input type="email" inputMode="email" autoComplete="off" />
          </Form.Item>
          <Form.Item name="serviceProviderId" label={t("Service Provider ID")}>
            <Input />
          </Form.Item>
          <Form.Item name="phone" label={t("Phone")}>
            <Input type="tel" inputMode="tel" autoComplete="off" />
          </Form.Item>
          <Form.Item name="companyName" label={t("Company Name")}>
            <Input />
          </Form.Item>
          <Form.Item
            name="maxEmployees"
            label={t("Max Employees")}
            tooltip={t("Currently allowed: {{value}}", { value: data?.settings?.maxEmployees })}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
          <Form.Item
            name="spaceLimit"
            label={t("Max Space")}
            tooltip={t("Currently allowed: {{value}}", {
              value: data?.settings?.spaceLimit[data?.settings?.spaceLimit?.length - 1]?.max
            })}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
          <Form.Item
            name="defaultRoles"
            label={t("Allowed Default Roles")}
            tooltip={t("Currently allowed: {{value}}", { value: data?.settings?.defaultRoles })}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
          <Form.Item
            name="allowedCustomRoles"
            label={t("Allowed Custom Roles")}
            tooltip={t("Currently allowed: {{value}}", {
              value: data?.settings?.allowedCustomRoles
            })}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditServiceProviders;
